import React, { useEffect, useState, lazy } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { Button } from '../ui/Button';
const slides = [{
  id: 1,
  title: 'Premium Wireless Earbuds',
  subtitle: 'Experience True Sound',
  description: 'Up to 50% off on selected earbuds. Free shipping on orders over PKR 5,000.',
  image: 'https://images.unsplash.com/photo-1606220588913-b3aacb4d2f46?w=1200',
  cta: 'Shop Earbuds',
  link: '/products?category=earbuds',
  bgColor: 'from-blue-600 to-blue-800'
}, {
  id: 2,
  title: 'Smart Watches Collection',
  subtitle: 'Stay Connected, Stay Fit',
  description: 'Latest smartwatches from Apple, Samsung, and Amazfit. Starting from PKR 44,999.',
  image: 'https://images.unsplash.com/photo-1546868871-7041f2a55e12?w=1200',
  cta: 'Explore Watches',
  link: '/products?category=smart-watches',
  bgColor: 'from-purple-600 to-purple-800'
}, {
  id: 3,
  title: 'Gaming Gear Sale',
  subtitle: 'Level Up Your Game',
  description: 'Professional gaming accessories at unbeatable prices. Save up to 25%.',
  image: 'https://images.unsplash.com/photo-1527814050087-3793815479db?w=1200',
  cta: 'Shop Gaming',
  link: '/products?category=gaming-accessories',
  bgColor: 'from-green-600 to-green-800'
}];
export function HeroBanner() {
  const [currentSlide, setCurrentSlide] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);
  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };
  const goToPrev = () => {
    setCurrentSlide(prev => (prev - 1 + slides.length) % slides.length);
  };
  const goToNext = () => {
    setCurrentSlide(prev => (prev + 1) % slides.length);
  };
  return <section className="relative overflow-hidden" aria-label="Featured promotions" data-id="element-200" data-mp="9oyoig4zt5ul">
      <div className="relative h-[400px] md:h-[500px]" data-id="element-201" data-mp="enjeznug0b5u">
        {slides.map((slide, index) => <div key={slide.id} className={`absolute inset-0 transition-opacity duration-700 ${index === currentSlide ? 'opacity-100 z-10' : 'opacity-0 z-0'}`} data-id="element-202" data-mp="6n3kt1v65qfn" data-mpi={index}>
            <div className={`absolute inset-0 bg-gradient-to-r ${slide.bgColor}`} data-id="element-203" data-mp="1mxzs4jen26j" />
            <div className="absolute inset-0 bg-black/20" data-id="element-204" data-mp="gfrh7vi8lsdu" />
            <img src={slide.image} alt="" className="absolute right-0 top-0 h-full w-1/2 object-cover opacity-50 md:opacity-80" loading={index === 0 ? 'eager' : 'lazy'} data-id="element-205" data-mp="bfmydytuwlkg" />
            <div className="relative h-full px-6 md:px-10 flex items-center" data-id="element-206" data-mp="3evkcujz1wfol">
              <div className="max-w-sm md:max-w-md text-white relative z-10" data-id="element-207" data-mp="3exoqvuqnyv2l">
                <p className="text-sm md:text-base font-medium text-white/80 mb-2" data-id="element-208" data-mp="3ttw9wrqc5qga">
                  {slide.subtitle}
                </p>
                <h2 className="text-2xl md:text-4xl font-bold mb-3 leading-tight" data-id="element-209" data-mp="1923w356i516q">
                  {slide.title}
                </h2>
                <p className="text-sm md:text-base text-white/90 mb-5" data-id="element-210" data-mp="142hgwq745ava">
                  {slide.description}
                </p>
                <Link to={slide.link} data-id="element-211" data-mp="1bov2a2zbt9lk">
                  <Button variant="secondary" size="lg" data-id="element-212" data-mp="1gmegj2w0xmdi">
                    {slide.cta}
                  </Button>
                </Link>
              </div>
            </div>
          </div>)}
      </div>

      {/* Navigation arrows */}
      <button onClick={goToPrev} className="absolute left-4 top-1/2 -translate-y-1/2 z-20 w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-colors" aria-label="Previous slide" data-id="element-213" data-mp="16ogu8kxq5znj">
        <ChevronLeftIcon className="w-6 h-6" data-id="element-214" data-mp="1ll7usxj4xheq" />
      </button>
      <button onClick={goToNext} className="absolute right-4 top-1/2 -translate-y-1/2 z-20 w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-colors" aria-label="Next slide" data-id="element-215" data-mp="1lkpqddmbjwvq">
        <ChevronRightIcon className="w-6 h-6" data-id="element-216" data-mp="2i3dxozunoref" />
      </button>

      {/* Dots */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-20 flex items-center gap-2" data-id="element-217" data-mp="uej2naw57wic">
        {slides.map((_, index) => <button key={index} onClick={() => goToSlide(index)} className={`w-2.5 h-2.5 rounded-full transition-all ${index === currentSlide ? 'bg-white w-8' : 'bg-white/50 hover:bg-white/70'}`} aria-label={`Go to slide ${index + 1}`} aria-current={index === currentSlide ? 'true' : 'false'} data-id="element-218" data-mp="pf6fsq59upfr" data-mpi={index} />)}
      </div>
    </section>;
}